import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const OutSourcingDetail = {
	name: NAME,
	apiProvider,
	router,
};
